import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BpSwitchComponent } from "@modules/core/components/bp-switch/component/bp-switch.component";
import { FormsModule } from "@angular/forms";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";

@NgModule({
	declarations: [BpSwitchComponent],
	imports: [CommonModule, FormsModule, TranslationPipeModule],
	exports: [BpSwitchComponent]
})
export class BpSwitchModule {}
